import React from "react";
import { motion } from "framer-motion";
import { PROCESS } from "../data/content";

const Process = () => {
    return (
        <section id="process" className="relative py-24 lg:py-32 bg-graphite/30" data-testid="process">
            <div className="max-w-7xl mx-auto px-5 lg:px-10">
                <div className="grid lg:grid-cols-12 gap-10 mb-16 items-end">
                    <div className="lg:col-span-7">
                        <div className="pill"><span className="accent-dot" />How we work</div>
                        <h2 className="mt-5 font-display text-5xl lg:text-6xl text-ivory tracking-tight">
                            Four weeks to a working demo.<br />
                            <span className="italic text-gold-shimmer">Always.</span>
                        </h2>
                    </div>
                    <p className="lg:col-span-5 text-ivory/60 leading-relaxed">
                        No 80-page SOWs. No "phase zero" theatre. Quote in 48 hours, demo in week two, production timeline locked in week three.
                    </p>
                </div>

                <div className="relative grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-gold/10 border border-gold/10 rounded-2xl overflow-hidden">
                    {PROCESS.map((p, i) => (
                        <motion.div
                            key={p.step}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: i * 0.08 }}
                            className="bg-obsidian p-8 lg:p-10 relative group"
                            data-testid={`process-step-${p.step}`}
                        >
                            <div className="flex items-center justify-between mb-8">
                                <span className="font-display text-5xl text-gold/30 group-hover:text-gold/60 transition-colors">{p.step}</span>
                                <div className="w-2 h-2 rounded-full bg-teal shadow-[0_0_12px_#2DD4BF]" />
                            </div>
                            <h3 className="font-display text-2xl text-ivory mb-3">{p.title}</h3>
                            <p className="text-sm text-ivory/60 leading-relaxed">{p.text}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Process;
